export const launchpadContainerId = 'appcues-launchpad-container';
